"use client";

import { createContext, useContext, useEffect, useState } from "react";

const RuntimeConfigContext = createContext(null);

export function RuntimeConfigProvider({ children }) {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    let mounted = true;

    fetch("/frontend-api/runtime-config")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to load runtime config");
        return res.json();
      })
      .then((data) => {
        if (mounted) setConfig(data);
      })
      .catch((err) => {
        console.error("Runtime config error:", err);
      });

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <RuntimeConfigContext.Provider value={config || {}}>{children}</RuntimeConfigContext.Provider>
  );
}

export function useRuntimeConfig() {
  const ctx = useContext(RuntimeConfigContext);
  if (!ctx) {
    throw new Error("useRuntimeConfig must be used inside RuntimeConfigProvider");
  }
  return ctx;
}
